import React, {Children} from 'react'
import getCurrentSelectedFilters from '../../../context/search/helpers/getCurrentSelectedFilters'
import useSearch from '../../../context/search/useSearch'
import SearchProductCard from './Components/SearchProductCard'
import SearchNoResultBlock from './SearchNoResultsBlock';

import { InView } from 'react-intersection-observer';

interface PaginationLinkProps {
  index: number
  active: boolean,
}


// const usePageInView = ({productIndex, productsPerPage} : {productIndex: number, productsPerPage: number}) => {
//   const { ref, inView } = useInView({
//     threshold: 0,
//   });
//   const page = Math.floor((productIndex + 1) / productsPerPage) + 1;
//   const pageInView = inView ? page : null;
//   return {ref, pageInView}
// }

const PaginationNavLink : React.FC<PaginationLinkProps> = ({ active, index, children }): JSX.Element => {
  const {inputEventHandlers} = useSearch()
  const child: any = Children.only(children)
  const childProps = {
    onClick: () => active ? null : inputEventHandlers.handleUpdatePageIndex(index, true)
  }
  return React.cloneElement(child, childProps)
}

interface PaginationProps {
  pageCount: number
  pageIndex: number,
}

const Pagination: React.FC<PaginationProps> = ({ pageCount, pageIndex }): JSX.Element => {
  return (
    <div className={'sf-search-filtered-products-pagination'}>
      {pageCount > 1 ? (
        <ol>
          <PaginationNavLink active={pageIndex === 1} index={(pageIndex - 1)}>
            <li className={`previous ${pageIndex === 1 ? 'disabled' : ''}`}>
            </li>
          </PaginationNavLink>
          {[...Array(pageCount).keys()].map((i) => {
            const active = (pageIndex === i + 1)
            return (
              <PaginationNavLink active={active} index={(i + 1)} key={i}>
                <li className={active ? 'active' : ''} >
                  { i + 1}
                </li>
              </PaginationNavLink>
            )
          })}
          <PaginationNavLink active={pageIndex === pageCount} index={(pageIndex + 1)}>
            <li className={`next ${pageIndex === pageCount ? 'disabled' : ''}`}>
            </li>
          </PaginationNavLink>
        </ol>
      ) : ''}
    </div>)
}

interface iProductListStrings {
  dataSet: {
    hoverText: string
    fromText: string;
    colourSwatches: string;
    roastText: string;
    tasteText: string;
    quickAddText: string
    quickAddPlus: string
  }
}

const SearchFilteredProducts: React.FC<iProductListStrings> = ({ dataSet }): JSX.Element => {

  const {productSearchResult, searchFilters, config, pageIndex, filtersLoading, inputEventHandlers} = useSearch()

  const pageCount = productSearchResult ? Math.ceil(productSearchResult.total / config.rProductsPerPage) : 0;
  
  if (!searchFilters) {
    return null
  }
  
  const selectedFilters = getCurrentSelectedFilters(searchFilters)

  if ((!selectedFilters || selectedFilters.length < 1) && !productSearchResult) {
    return null
  }

  // dispatch event when component loads
  const resultsLoadedEvent = new CustomEvent('results_loaded', {
    detail: { 
      productSearchResult,
      searchTerms: window.location.search.replace('?q=', '')
    }
  });
  document.dispatchEvent(resultsLoadedEvent);

  return (
    <React.Fragment>
      {productSearchResult && productSearchResult.products.length === 0 ?
        <SearchNoResultBlock /> :

        <div className={`sf-search-filtered-products-container ${filtersLoading ? 'is-loading' : ''}`}>
          {(productSearchResult && productSearchResult.products) &&
            <React.Fragment>
              <div className="cl-product-card-container grid-list">
                {productSearchResult.products.map((product, index) => {

                  if (config.rLoadMoreMode === 'loadMore') {

                    return (
                      <InView key={index} as="div" onChange={(inView) => {
                        const newPageIndex = inView ? Math.floor(index / config.rProductsPerPage) + 1 : null;
                        if (newPageIndex && newPageIndex !== pageIndex) {
                          inputEventHandlers.handleUpdatePageIndex(newPageIndex, false)
                        }

                      }} className="grid-item">
                        <SearchProductCard
                          product={product}
                          cardLangStrings={dataSet}
                        />
                      </InView>
                    )
                  } else {
                    return <div key={index} className="grid-item"><SearchProductCard product={product} cardLangStrings={dataSet} /></div>
                  }
                })}
              </div>

              {config.rLoadMoreMode === 'paginate' && <Pagination pageCount={pageCount} pageIndex={pageIndex} />}
          
              {config.rLoadMoreMode === 'loadMore' && pageIndex < pageCount && <InView as="div" onChange={(inView) => {
                if (inView) {
                  const newPageIndex = Math.min(pageIndex + 1, pageCount);
                  inputEventHandlers.handleUpdatePageIndex(newPageIndex, true);
                }
              }}>
                <div className="product-list-loader">
                  <span className="loading-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><path d="M20.201 5.169c-8.254 0-14.946 6.692-14.946 14.946 0 8.255 6.692 14.946 14.946 14.946s14.946-6.691 14.946-14.946c-.001-8.254-6.692-14.946-14.946-14.946zm0 26.58c-6.425 0-11.634-5.208-11.634-11.634 0-6.425 5.209-11.634 11.634-11.634 6.425 0 11.633 5.209 11.633 11.634 0 6.426-5.208 11.634-11.633 11.634z" opacity=".2" /><path d="M26.013 10.047l1.654-2.866a14.855 14.855 0 00-7.466-2.012v3.312c2.119 0 4.1.576 5.812 1.566z"><animateTransform attributeName="transform" attributeType="xml" dur="0.5s" from="0 20 20" repeatCount="indefinite" to="360 20 20" type="rotate" /></path></svg>
                  </span>
                </div>
              </InView>}

            </React.Fragment>
          }
        </div>}
    </React.Fragment>
  )
}

export default SearchFilteredProducts